import { Store } from "@mui/icons-material";

const apiEndpoints = {
  BASE_URL: process.env.REACT_APP_URL,
  BASE_PUBLIC_URL: process.env.REACT_APP_AUTH_URL,
  STORE: {
    GETALLSTORES: "Public/GetStores/GetAllStores",
    GET_STORE_AVAILABLE: `Public/GetStores/ByID`,
    GET_STORE_SLOTS: `Public/GetAppointmentSlot`,
    GET_STORE_NAMES: "Public/GetStores/StoreNames"
  },
  LOGIN: {
    LOGIN_USER: "Account/Login",
    FORGET_PASSWORD: "Account/Password/Forget",
    RESET_PASSWORD: "Account/Password/Reset",
    CHANGE_PASSWORD: "Account/Password/Change",
  },
  Customer: {
    UpsertCustomer: "Public/UpsertCustomer",
    GetCustomer: "Public/GetCustomers",
    CHECK_COMMERCE_CUSTOMER: "Public/CheckCustomer",
    Commerce_Add_Customer: "Public/CreateCustomer",
  },
  Service: {
    GET_ALL_SERVICE: `Public/GetServicesTypes`,
  },
  Appoinment: {
    createAppointment: `Appointments/Web/CreateAppointment`,
    createKnownAppointment: `Public/Create`,
  },
  VALIDATE_ADDRESS:{
    EXPERIAN:'Public/Experian/SearchAddressByKeywords',
    GET_FORMAT_ADDRESS:'Public/Experian/GetFormatedAddressByKey',
    VALIDATE_EMAIL:'Public/Experian/ValidateEmail',
    EXPERIAN_SEARCH_BY_KEYWORDS:'Public/Experian/SearchAddressByKeywords',
    GETEXPERIAN_CONFIG: 'Public/Experian/GetExperianConfig',
    VALIDATEPHONE: 'Public/ValidatePhone'
  },
  CAPTCHA: {
    VERIFY_CAPTCHA: "Public/ValidateCaptcha"
  }
};

export default apiEndpoints;
